<template>
  <main>
    <h1 v-if="success" class="sli lundi b-b">{{ success[0].title }}</h1>
    <div class="sli" v-html="success[0].text"></div>
  </main>
</template>

<script>
export default {
  name: "success",
  data() {
    return {
      lang: "en"
    };
  },
  created() {
    if (this.$store.state.success.length === 0) {
      this.$store.dispatch("loadSuccess");
    }
  },
  computed: {
    success() {
      return this.$store.state.success;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
